import { render, staticRenderFns } from "./DashboardElmtDataContext.vue?vue&type=template&id=124877ca&"
import script from "./DashboardElmtDataContext.vue?vue&type=script&lang=js&"
export * from "./DashboardElmtDataContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports